import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchcategory(action) {
  try {
    let page = (action.payload && action.payload.page) || 1;
    const token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    const res = yield fetch(`${appConfig.ip}/vehicleInvntry/catgry?orgId=${user.orgId}&limit=10&page=${page}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_CATEGORY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_CATEGORY_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchsubcategory(params) {

  let ctgryId = (params.params && params.params.catgryId) || null;
  let page = (params.params && params.params.page) || 1;
  let user = JSON.parse(localStorage.getItem("user"));
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/vehicleInvntry/subCategory?ctgryId=${ctgryId}&orgId=${user.orgId}&isActive=true&limit=10&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_SUB_CATEGORY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_SUB_CATEGORY_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchRatecard(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let pageno = !value.value
    ? 1
    : value.value.pageno === undefined
      ? 1
      : value.value.pageno;
  let search = (value.value && value.value.search) || "";
  try {
    const res = yield fetch(
      `${appConfig.ip}/rateCard?orgId=${id}&isActive=true&limit=10&ser=${search}&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_RATECARD_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_RATECARD_FAIL_ACTION, error: err });
    } else {
    }
  }
}


function* addRateCard(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));


  const data = {
    name: value.value.name,
    // baseKm: value.value.baseKm,
    basePrice: value.value.basePrice,
    catgry: value.value.catgry,
    subCatgry: value.value.subCatgry,
    orgId: user.orgId,
    userId: user.id,
    runnerId: user.id,
    // cmmsn: value.value.cmmsn,
    perKmCharg: value.value.perKmCharg,
    // detentnCharg:value.value.detentnCharg,

  };

  try {
    const res = yield fetch(`${appConfig.ip}/rateCard`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.ADD_RATECARD_SUCCESS_ACTION,
        payload: resJSON,
      });

      if (resJSON.error === true) {
        yield toast.error(resJSON.err.message, {
          autoClose: 3000,
          className:"toastClass"
        });
      } else {
        yield toast.success("Rate card added successfully", {
          autoClose: 3000,
          className:"toastClass"
        });
      }



      yield put({
        type: actionTypes.FETCH_RATECARD_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_RATECARD_FAIL_ACTION,
        error: err,
      });
    }
  }
}





function* editRateCard(value) {
  let id = value.id;
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  // let data = value.params;
  const data = {
    name: value.value.name,
    // baseKm: value.value.baseKm,
    basePrice: value.value.basePrice,
    catgry: value.value.catgry,
    subCatgry: value.value.subCatgry,
    orgId: user.orgId,
    userId: user.id,
    runnerId: user.id,
    // cmmsn: value.value.cmmsn,
    perKmCharg: value.value.perKmCharg,
    // detentnCharg:value.value.detentnCharg,
  };
  try {
    const response = yield fetch(
      `${appConfig.ip}/rateCard?orgId=${user.orgId}&isActive=true&catgry=${value.value.catgry}&subCatgry=${value.value.subCatgry}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      let errJSON = {};
      try {
        errJSON = yield response.json();
      } catch { }
      throw Object.assign(response, errJSON);
    } else {
      const resJSON = yield response.json();
      let rateCard = resJSON.rows.filter(data => data.id !== id)
      if (rateCard.length > 0) {
        yield toast.error(`You have been already added a rate card with same category & subcategory`, {
          autoClose: 3000,
          className:"toastClass"
        });
      } else {
        const res = yield fetch(`${appConfig.ip}/rateCard/` + id, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch { }
          throw Object.assign(res, errJSON);
        } else {
          const resJSON = yield res.json();
          yield put({ type: actionTypes.FETCH_RATECARD_INIT_ACTION });
          yield put({
            type: actionTypes.EDIT_RATECARD_SUCCESS_ACTION,
            payload: resJSON,
          });
          yield toast.success("Rate card updated successfully", {
            autoClose: 3000,
            className:"toastClass"
          });
        }
      }
      // else {      
      // }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.EDIT_RATECARD_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}


function* deleteRateCard(params) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let id = params.data.id;

  let data = {
    name: params.data.name,
    // baseKm: params.data.baseKm,
    basePrice: params.data.basePrice,
    catgry: params.data.catgry,
    subCatgry: params.data.subCatgry,
    orgId: user.orgId,
    // cmmsn: params.data.cmmsn,
    perKmCharg: params.data.perKmCharg,
    // detentnCharg:params.data.detentnCharg,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/rateCard/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ isActive: false, ...data }),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: actionTypes.FETCH_RATECARD_INIT_ACTION });
      yield put({
        type: actionTypes.DELETE_RATECARD_SUCCESS_ACTION,
        payload: id,
      });
      yield toast.success("Rate card deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_RATECARD_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchloadmetricmap(value) {
  let page = (value.value && value.value.page) || 1;

  const catID = (value.value && value.value.catId) || "";
  let subCatID = (value.value && value.value.subCatID) || "";
  let catIdParam = "";
  let subcatIdParam = "";
  if (catID) {
    catIdParam = `&catgry=${catID}`;
  }
  if (subCatID) {
    subcatIdParam = `&subCatgry=${subCatID}`;
  }

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/loadMetricsMap?limit=10&page=${page}${catIdParam}${subcatIdParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_LOAD_METRIC_MAP_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_LOAD_METRIC_MAP_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* RateCardActionWatcher() {
  yield takeEvery(actionTypes.FETCH_CATEGORY_INIT_ACTION, fetchcategory);
  yield takeEvery(actionTypes.FETCH_SUB_CATEGORY_INIT_ACTION, fetchsubcategory);
  yield takeEvery(actionTypes.FETCH_RATECARD_INIT_ACTION, fetchRatecard);
  yield takeEvery(actionTypes.ADD_RATECARD_INIT_ACTION, addRateCard);
  yield takeEvery(actionTypes.EDIT_RATECARD_INIT_ACTION, editRateCard);
  yield takeEvery(actionTypes.DELETE_RATECARD_INIT_ACTION, deleteRateCard);
  yield takeEvery(
    actionTypes.FETCH_LOAD_METRIC_MAP_INIT_ACTION,
    fetchloadmetricmap
  );
}
